import styled from 'styled-components';
import { textAlignCenter, fontSize1, fontColorWhite } from './Style';

export const WhiteText = styled.div`
    ${textAlignCenter}
    ${fontSize1}
    ${fontColorWhite}
`



// WEBPACK FOOTER //
// ./src/Text.js